export const Status = () => import("./Status.vue");
export const Offices = () => import("./Offices.vue");
export const OfficeFolders = () => import("./OfficeFolders.vue");
